export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  TRANSLATE_REPLY: 'TRANSLATE_REPLY',
  NOTE: 'NOTE',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
